import { useTranslation } from 'react-i18next';
import { Page } from '@web/components/page';
import { AboutUsScreen, AboutUsScreenProps } from 'shared/screens/about-us';
import { withServerProps } from '@web/library/with-server-props';

export default function AboutUs(props: AboutUsScreenProps) {
  const { t } = useTranslation('screens');

  return (
    <Page
      {...props}
      register={(seo) =>
        seo.setTitle(t('about_us.title')).setDescription(t('about_us.description'))
      }
    >
      <AboutUsScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps();
